<template>
	<div>
		<Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true">
			<template #action>
        <div class="flex">
          <!-- 固定休 -->
          <div class="mr-5 form border-2 border-light-blue-500 font-bold flex">
            <div v-if="openBar" class="h-full overflow-y-auto overflow-x-hidden py-2 text-sm">
              <div class="text-xs mx-2">
                RLSスタッフの固定休（曜日）
                <p>※保存時にチェックします</p>
              </div>
              <div v-for="(week, i) in Object.keys(holidayWeeks)" :key="'hw'+i" class="mt-3 mb-2">
                <div class="p-2 w-full bg-light-blue-200 text-gray-700">
                  {{ holidayWeeks[week].name }}曜日
                </div>
                <div class="staff-grid m-2">
                  <div v-for="(staff, j) in holidayWeeks[week].staffs" :key="'hw'+i+'hs'+j" class="text-xs p-2 rounded border border-gray-400">
                    {{ staff }}
                  </div>
                </div>
              </div>
            </div>

            <!-- 開閉バー -->
            <div class="h-full border-light-blue-500 bg-light-blue-500 text-white px-1.5 py-10 font-bold bar cursor-pointer" @click="openBar=!openBar">
              <div v-if="openBar">
                スタッフ固定休 一覧 &#12288; ◀ ◀ ◀
              </div>
              <div v-else>
                スタッフ固定休 一覧 &#12288; ▶ ▶ ▶
              </div>
            </div>
          </div>
          <!-- マスタ -->
          <div class="overflow-auto form">
            <div class="flex justify-between">
              <div class="whitespace-nowrap font-bold cursor-pointer" @click="openCalendar()">
                <p class="border-b border-indigo-700 text-indigo-700 text-sm w-fit">カレンダーを見る</p>
                <p v-if="auth" class="text-red-700 text-xs">※マスタを変更した際は、保存しなければ反映されません。</p>
              </div>
              <SecondaryButton
                text="閉じる"
                class="w-fit block my-1 mr-1 px-5"
                @click="closed()"
              >
              </SecondaryButton>
            </div>

            <div v-if="open" class="w-full">

              <!-- 物件名 -->
              <div class="flex">
                <WmsSuggestInput
                  v-if="isNew"
                  name="site"
                  caption="物件名（ビルメンからRLSの作業内容コード1150をリストアップしています）"
                  :clearable="true"
                  :selectionItems="siteList"
                  :displayField="['site1', 'site2']"
                  v-model="val.site"
                  @selected="siteSelected"
                >
                </WmsSuggestInput>
                <div v-else class="text-lg font-bold text-gray-700">{{ val.site }}</div>

                <div class="ml-5">
                  <PrimaryButton
                    text="物件概要書"
                    class="bg-yellow-600"
                    size="xs"
                    @click="openOutline(val.siteCode)"
                  />
                </div>
              </div>
              <div class="text-xs text-gray-700">{{ val.siteCode }}</div>

              <!-- 住所 -->
              <div class="mt-2 text-xs font-bold text-gray-700">(住所)</div>
              <div class="text-sm text-gray-700">
                {{ val.address1 }} {{ val.address2 }}
              </div>

              <div class="flex justify-around">

                <div v-if="auth" class="mt-3 mb-1">
                  <PrimaryButton
                    text="マスタを削除"
                    class="bg-red-700"
                    size="xs"
                    @click="deleteBtn(val.siteCode)"
                  />
                </div>

                <div v-if="byMonth" class="text-sm font-bold mx-auto mb-1 mt-auto animate-pulse">作業部門コードが「5」のため「毎週」は選択できません（登録ミス防止のため）</div>

                <!-- 勤務追加 -->
                <div @click="add()" class="cursor-pointer w-fit ml-auto mb-1 mt-auto">
                  <PlusCircleIcon class="text-indigo-500 active:text-ingigo-600 w-7 h-7"/>
                </div>

              </div>

              <div v-for="(row, i) in works" :key="'w'+i" class="border border-blue-500 rounded p-2 mb-5">

                <!-- 適用開始日 -->
                <div class="flex">
                  <WmsDateInput
                    v-if="i==0"
                    :name="i+'start'"
                    caption="適用開始日"
                    v-model="row.startDate"
                    :clearable="i==0"
                    :min="minDay"
                    :class="!row.startDate?'bg-red-100':''"
                  />
                  <div v-else class="bg-gray-300 py-2 px-3 text-sm rounded w-44 cursor-not-allowed">
                    {{ row.startDate }}
                  </div>
                  <div class="mt-auto text-xs font-bold ml-2 mb-2 text-gray-700">から適用</div>

                  <div class="ml-auto">
                    <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-6 h-6" @click="deleteRow(i)"/>
                  </div>
                </div>

                <!-- 月 -->
                <div class="flex mt-6">
                  <div v-for="(m) in [1,2,3,4,5,6,7,8,9,10,11,12]" :key="i+'m'+m"
                    class="mx-1 p-2 text-sm text-white font-bold rounded flex-1 text-center cursor-pointer whitespace-nowrap"
                    :class="row.months.includes(m)?'bg-blue-800':'bg-gray-300'"
                    @click="clickMonth(row, m)"
                  >
                    {{ m }} 月
                  </div>
                </div>

                <!-- ゴミ出し -->
                <div class="p-2 bg-green-100 mt-6">
                  <div class="text-green-700 font-bold">ゴミ出し</div>

                  <div class="flex items-start mt-1">
                    <div v-for="(w) in weekList" :key="i+'w'+w.id"
                      class="mx-1 p-1 text-sm text-white font-bold rounded flex-1 text-center w-135px"
                      :class="row['trash' + w.id]&&row['trash' + w.id].length?'bg-green-800':'bg-gray-300'"
                    >
                      <div @click="clickWeek(row, 'trash' + w.id, 'trashStaff' + w.id)" class="cursor-pointer p-1">{{ w.name }}</div>

                      <!-- 形態 -->
                      <multiselect
                        v-model="row['trash' + w.id]"
                        :options="attendanceOptions"
                        :multiple="true"
                        :close-on-select="false"
                        :show-labels="false"
                        :searchable="false"
                        :allow-empty="true"
                        :hide-selected="true"
                        class="multiselect text-sm h-full"
                        placeholder=""
                      >
                      </multiselect>

                      <!-- 担当スタッフ -->
                      <div class="mt-1">
                        <WmsSuggestInput
                          placeholder="担当者"
                          :clearable="true"
                          :selectionItems="staffList"
                          displayField="userName"
                          v-model="row['trashStaff' + w.id]"
                          @selected="staffSelected(row, 'trashStaffId' + w.id, $event)"
                          class="staff-input"
                          :class="row['trash' + w.id + 'Color']"
                        >
                        </WmsSuggestInput>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 清掃 -->
                <div class="p-2 bg-purple-100 mt-5">
                  <div class="text-purple-700 font-bold">清掃</div>

                  <div class="flex items-start mt-1">
                    <div v-for="(w) in weekList" :key="i+'w'+w.id"
                      class="mx-1 p-1 text-sm text-white font-bold rounded flex-1 text-center w-135px"
                      :class="row['clean' + w.id]&&row['clean' + w.id].length?'bg-purple-800':'bg-gray-300'"
                    >
                      <div @click="clickWeek(row, 'clean' + w.id, 'cleanStaff' + w.id)" class="cursor-pointer p-1">{{ w.name }}</div>

                      <!-- 形態 -->
                      <multiselect
                        v-model="row['clean' + w.id]"
                        :options="attendanceOptions"
                        :multiple="true"
                        :close-on-select="false"
                        :show-labels="false"
                        :searchable="false"
                        :allow-empty="true"
                        :hide-selected="true"
                        class="multiselect text-sm h-full clean"
                        placeholder=""
                        @input="getHolidayType(row)"
                      >
                      </multiselect>

                      <!-- 担当スタッフ -->
                      <div class="mt-1">
                        <WmsSuggestInput
                          placeholder="担当者"
                          :clearable="true"
                          :selectionItems="staffList"
                          displayField="userName"
                          v-model="row['cleanStaff' + w.id]"
                          @selected="staffSelected(row, 'cleanStaffId' + w.id, $event)"
                          class="staff-input"
                          :class="row['clean' + w.id + 'Color']"
                        >
                        </WmsSuggestInput>
                      </div>
                    </div>
                  </div>

                  <!-- 祝日 -->
                  <div class="mt-6 text-sm font-bold text-gray-700">
                    <Icon
                      iconName="ExclamationCircle"
                      class="text-gray-700 inline-block"
                    />
                    祝日の場合 （システムで自動判定しています。ご確認ください。）
                  </div>
                  <div class="flex text-white font-bold text-sm cursor-not-allowed">
                    <div class="flex-1 rounded p-2 text-center mx-2" :class="row.holiday==1?'bg-purple-700':'bg-gray-300'">振替する</div>
                    <div class="flex-1 rounded p-2 text-center mx-2" :class="row.holiday==2?'bg-purple-700':'bg-gray-300'">清掃なし</div>
                  </div>

                  <!-- 振替指定曜日 -->
                  <div v-if="row.holiday==1" class="p-2 mt-3 border border-purple-700 rounded">
                    <div class="text-sm font-bold text-gray-700">振替指定曜日（祝日だった場合、何曜日に振替するか指定できます）</div>
                    <div class="mt-2 ml-3 text-xs font-bold text-gray-700">
                      <p>・指定なしの場合 ➡ システムで自動振替</p>
                      <p>・指定した曜日が祝日 ➡ システムで別曜日に自動振替</p>
                      <p>・基本的に祝日以降の日に振替、月内に収まらない場合 ➡ 前営業日に振替（翌月に持ち越さない）</p>
                      <p>※「予定・結果」で手動で振替可能</p>
                    </div>

                    <div class="flex mt-2">
                      <div v-for="(w) in weekList" :key="i+'w'+w.id"
                        class="mx-1 p-1 text-sm text-white font-bold rounded flex-1 text-center w-32"
                        :class="row['clean' + w.id]&&row['clean' + w.id].length?'bg-purple-500':'bg-gray-300'"
                      >

                        <div class="p-1">{{ w.name }}</div>

                        <!-- 振替指定曜日 -->
                        <select
                          v-model="row['exchange' + w.id]"
                          class="text-center text-sm rounded py-1 text-gray-800 font-bold border-0"
                          :disabled="!row['clean' + w.id]||!row['clean' + w.id].length"
                        >
                          <option
                            :value="null"
                            class="bg-white"
                          >
                          </option>
                          <option v-for="ex in weekList"
                            :key="i+'ex'+ex.num"
                            :value="ex.num"
                            :disabled="ex.id==w.id"
                            class="bg-white"
                          >
                            {{ ex.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-transparent">{{reload}}</div>

            <div v-if="auth" class="mx-2 my-3">
              <PrimaryButton
                v-if="!loading"
                text="保存"
                size="normal"
                class="w-full"
                @click="save()"
              />
              <div v-else class="text-lg text-center text-gray-700">保存中...</div>
            </div>
            <div v-else class="mx-2 my-3">
              <div class="text-gray-700 font-bold text-center"> 4グループ以上のみ更新可能 </div>
              <SecondaryButton
                text="閉じる"
                class="w-full"
                @click="closed()"
              >
              </SecondaryButton>
            </div>
          </div>
        </div>
			</template>
		</Modal>
    <!-- カレンダー -->
    <RlsCalendarModal
      v-model="siteCalendarOpen"
      :target="siteCalendar"
      :open="siteCalendarOpen"
      @closed="closedCalendar"
    />
	</div>
</template>
<script>

import Modal from '@components/Modal.vue'
import Icon from '@components/Icon.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
import Multiselect from 'vue-multiselect'
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import RlsCalendarModal from '../components/RlsCalendarModal.vue'
import { TrashIcon, PlusCircleIcon  } from '@vue-hero-icons/solid'
import { WEEK_NUM_TO_NAME } from '@libs/constants'
import * as logManager from '@managers/logManager'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import * as moment from 'moment'
import BigNumber from 'bignumber.js'

const ITEM = {
	siteCode: '',
	site: '',
  address1: '',
  address2: ''
}

const WORK = {
  startDate: moment().format('YYYY-MM-01'),
  trashStaff: '',
  cleanStaff: '',
  months: [1,2,3,4,5,6,7,8,9,10,11,12],
  trashMon: [],
  trashTue: [],
  trashWed: [],
  trashThu: [],
  trashFri: [],
  trashSat: [],
  cleanMon: [],
  cleanTue: [],
  cleanWed: [],
  cleanThu: [],
  cleanFri: [],
  cleanSat: [],
  trashStaffMon: '',
  trashStaffTue: '',
  trashStaffWed: '',
  trashStaffThu: '',
  trashStaffFri: '',
  trashStaffSat: '',
  cleanStaffMon: '',
  cleanStaffTue: '',
  cleanStaffWed: '',
  cleanStaffThu: '',
  cleanStaffFri: '',
  cleanStaffSat: '',

  holiday: null,
}

const ATTENDANCE = [
        {id: '00', name: '毎週'},
        {id: '01', name: '第1'},
        {id: '02', name: '第2'},
        {id: '03', name: '第3'},
        {id: '04', name: '第4'},
        {id: '05', name: '第5'},
        {id: '10', name: '隔週'}
      ]

const ATTENDANCE2 = [
        {id: '01', name: '第1'},
        {id: '02', name: '第2'},
        {id: '03', name: '第3'},
        {id: '04', name: '第4'},
        {id: '05', name: '第5'}
      ]

export default {
	components: {
		Modal,
    Icon,
    WmsSuggestInput,
    WmsDateInput,
    Multiselect,
    TrashIcon,
    PrimaryButton,
    SecondaryButton,
    PlusCircleIcon,
    RlsCalendarModal
	},

	props: {
		target: {
			type: Object
		},
		open: {
			type: Boolean,
			default: false
		},
    staffList: {
      type: Array
    }
	},

	data() {
		return {
      loading: false,
      reload: 0,
			// 新規作成
			isNew: false,
      // データ
      val: utils.clone(ITEM),
      // 勤務データ
      works: [utils.clone(WORK)],
      // 曜日リスト
      weekList: [
        {id: 'Mon', name: '月', num: 1 },
        {id: 'Tue', name: '火', num: 2 },
        {id: 'Wed', name: '水', num: 3 },
        {id: 'Thu', name: '木', num: 4 },
        {id: 'Fri', name: '金', num: 5 },
        {id: 'Sat', name: '土', num: 6 }
      ],
      // 勤務形態リスト
      attendanceList: utils.clone(ATTENDANCE),
      // 物件リスト
      siteList: [],
      // クリックした物件情報
      selectedSiteData: {},

      // 物件カレンダーモーダル
      siteCalendarOpen: false,
      siteCalendar: null,

      // 月1・2設定
      byMonth: false,
      // 開閉バー
      openBar: false

		}
	},

	watch: {
		open() {
			if (!this.open) {
				return
			}
			this.getTarget()
		}
	},

	computed: {
    auth() {
      // 管理者権限がある場合
      if (this.$store.getters.auth && this.$store.getters.auth.adminAuth) {
        return true
      }
      // 4Ｇ以上
      const g = this.$store.getters.loginUserData
      if (g && g.groupNum && g.groupNum >= 4) {
        return true
      }
      // 事務センター・人事はOK
      if (g && g.departmentName) {
        if (g.departmentName == '事務センター' || g.departmentName == '人事総務経理') {
          return true
        }
      }
      return false
    },

    attendanceOptions() {
      return this.attendanceList.map((row) => row.name)
    },

    minDay() {
      if (this.works && this.works.length) {
        if (this.works.length == 1) {
          return null
        } else {
          return moment(this.works[1].startDate + 'T00:00:00').add(1, 'days').format('YYYY-MM-DD')
        }
      }
      return null
    },

    holidayWeeks() {
      const arr = {}
      if (this.staffList && this.staffList.length) {
        this.staffList.forEach(s => {
          if (s.holidayWeeks && s.holidayWeeks.length) {
            s.holidayWeeks.forEach(w => {
              // 日曜以外
              if (w != 0) {
                if (!arr[w]) {
                  const name = WEEK_NUM_TO_NAME[w]
                  arr[w] = { name, staffs: [] }
                }
                arr[w].staffs.push(s.userName)
              }
            })
          }
        })
      }
      return arr
    }
	},

	methods: {
		/**
		 * 表示するデータ取得
		 */
		async getTarget() {
			// 編集の場合
			if (this.target && Object.keys(this.target).length) {
				this.isNew = false
        const res = await backend.searchData('rls/getRlsMstBySiteCode', { siteCode: this.target.siteCode })
        if (res.data.data && res.data.data.length) {
          // すでに登録済みの場合
          if (res.data.data.length > 1 || res.data.data[0].months) {
            this.works = res.data.data
            for (let i = 0; i < this.works.length; i++) {
              const row = this.works[i]

              for (let j = 0; j < this.weekList.length; j++) {
                const w = this.weekList[j].id

                if (row['trash' + w] && row['trash' + w].length) {
                  this.getAttendanceName(row, ['trash' + w])
                }

                if (row['clean' + w] && row['clean' + w].length) {
                  this.getAttendanceName(row, ['clean' + w])
                }
              }
            }
          }

          // RLSマスタのスタッフごとで物件追加した場合
          if (this.target.type && this.target.week) {
            const w = this.works[0]
            const type = this.target.type
            const week = this.target.week

            // 指定の曜日に勤務が入っていない場合
            if (!w[type + week] || !w[type + week].length) {
              this.clickWeek(w, type + week, null)
            }

            // 指定のスタッフを入れる
            w[type + 'Staff' + week] = this.target.staff
            w[type + 'StaffId' + week] = this.target.staffId

            w[type + week + 'Color'] = 'yellow'
          }

          const w = res.data.data[0]
          this.val = {
            siteCode: w.siteCode,
            site: w.site,
            address1: w.address1,
            address2: w.address2
          }

          // 巡回清掃の条件と同じ場合は、毎週が選べないようにする
          const res2 = await backend.searchData('rls/isByMonth', { siteCode: this.target.siteCode })
          this.byMonth = false
            this.attendanceList = utils.clone(ATTENDANCE)
          if (res2.data.data) {
            this.byMonth = true
            this.attendanceList = utils.clone(ATTENDANCE2)
          }
        } else {
          alert('エラーが発生しました。')
          this.$emit('getData')
          this.closed()
        }

			// 新規の場合（ここに来ることはないが残しておく）
			} else {
				this.isNew = true
			}
		},

    /**
     * 物件選択
     */
    async siteSelected(e) {
      this.selectedSiteData = e
      this.val.siteCode = e.siteCode
      const res = await backend.searchData('akbsTable/getSiteAddress', { siteCode: e.siteCode })
      if (res && res.data.data && res.data.data.length) {
        const site = res.data.data[0]
        this.val.address1 = site.address1
        this.val.address2 = site.address2
      } else {
        this.val.address1 = null
        this.val.address2 = null
      }
    },

    /**
     * ユーザー選択
     */
    staffSelected(row, key, e) {
      row[key] = e.userId
    },

    /**
     * 勤務データ追加
     */
    async add() {
      if (this.works && this.works.length > 1 && !this.works[0].startDate) {
        await dialogs.showErrorDialog('適用開始日 未入力', '適用開始日を入力してください。')
        return
      }
      let row = utils.clone(WORK)
      // 一つ前の分をコピー
      if (this.works && this.works[0]) {
        row = utils.clone(this.works[0])
      }
      row.startDate = null
      this.works = [row].concat(this.works)
      this.reload++
    },

    /**
     * 勤務データ削除
     */
    deleteRow(i) {
      this.works.splice(i, 1)
      if (!this.works || !this.works.length) {
        this.add()
      }
      this.reload++
    },

    /**
     * 実施月選択
     * @param row 対象行
     * @param month クリックした月
     */
    clickMonth(row, month) {
      if (row.months.includes(month)) {
        row.months = row.months.filter((m) => {
          return m != month
        })
      } else {
        row.months.push(month)
      }
      this.reload++
    },

    /**
     * 曜日クリック
     * @param row 対象行
     * @param key クリックした曜日
     */
    clickWeek(row, key, staff) {
      if (row[key] && row[key].length) {
        row[key] = []

        // 担当者も空にする
        row[staff] = ''
      } else {
        row[key] = [this.attendanceList[0].name]
      }
      if (key.indexOf('clean') > -1) {
        this.getHolidayType(row)
      }

      this.reload++
    },

    /**
     * 選択された曜日の数・勤務形態によって祝日勤務を取得
     */
    getHolidayType(row) {
      let res = 0
      for (let i = 0; i < this.weekList.length; i++) {
        const w = this.weekList[i].id
        // 曜日ごとにカウント
        if (row['clean' + w] && row['clean' + w].length) {
          const tar = row['clean' + w]
          if (tar.includes('毎週')) {
            res = BigNumber(res).plus(4.3)
          } else if (tar.includes('隔週')) {
            res = BigNumber(res).plus(2.15)
          } else {
            if (tar.includes('第1')) {
              res = BigNumber(res).plus(1)
            }
            if (tar.includes('第2')) {
              res = BigNumber(res).plus(1)
            }
            if (tar.includes('第3')) {
              res = BigNumber(res).plus(1)
            }
            if (tar.includes('第4')) {
              res = BigNumber(res).plus(1)
            }
            if (tar.includes('第5')) {
              res = BigNumber(res).plus(0.34)
            }
          }
        }
      }
      res = Number(res)
      // console.log(res)
      if (res == 0) {
        row.holiday =  null

      // 週2回よりある
      } else if (res > 8.6) {
        // ゴミ出しのみ
        row.holiday =  2

      // 振替
      } else {
        row.holiday =  1
      }
      this.reload++
    },

    /**
     * 値を選択
     * @param val 値
     * @param row 対象行
     * @param tar プロパティー名
     */
    clickBtn(val, row, tar) {
      row[tar] = val
      this.reload++
    },

		/**
		 * 登録処理
		 */
		async save() {
      this.loading = true
      if (!this.works || !this.works.length) {
        this.add()
        this.loading = false
        await dialogs.showErrorDialog('勤務の詳細を入力してください', '曜日などを選択してください。')
        return
      }

      // 勤務データ
      for (let i = 0; i < this.works.length; i++) {
        const row = this.works[i]

        this.getHolidayType(row)

        if (!row.startDate) {
          this.loading = false
          await dialogs.showErrorDialog('適用開始日を選択してください', '契約開始日が分からない場合は、今月1日でも大丈夫です。')
          return
        }
        // 終了日を入れる
        if (i == 0) {
          row.endDate = null
        } else {
          row.endDate = moment(this.works[i - 1].startDate + 'T00:00:00').add(-1, 'days').format('YYYY-MM-DD')
        }

        if (!row.months || !row.months.length) {
          await dialogs.showErrorDialog('実施月が未選択です', '実施月は1つ以上選択してください。')
          this.loading = false
          return
        }
        row.months.sort((a, b) => a - b)

        let flg = false

        for (let j = 0; j < this.weekList.length; j++) {
          const w = this.weekList[j].id
          const wn = this.weekList[j].name
          // 曜日番号
          const num = this.weekList[j].num

          if (row['trash' + w] && row['trash' + w].length) {
            flg = true
            const att = await this.validateAttendance(row['trash' + w], wn, 'ゴミ出し')
            if (!att) {
              this.loading = false
              return
            }
            this.getAttendanceId(row, 'trash' + w)
          } else {
            delete row['trash' + w + 'Id']
          }

          if (row['clean' + w] && row['clean' + w].length) {
            flg = true
            const att = await this.validateAttendance(row['clean' + w], wn, '清掃')
            if (!att) {
              this.loading = false
              return
            }
            this.getAttendanceId(row, 'clean' + w)
          } else {
            delete row['clean' + w + 'Id']
            row['exchange' + w] = null
          }

          // 振替の場合
          if (row.holiday == 1) {

            if (row['exchange' + w]) {
              const ex = this.weekList.find((week) => { return week.num == row['exchange' + w] })
              // 振替先の曜日が毎週の場合
              if (ex && ex.id) {
                if (row['clean' + ex.id] && row['clean' + ex.id].includes('毎週')) {
                  await dialogs.showErrorDialog(wn + '曜日の振替指定曜日', ex.name + '曜日は「毎週」なので振替先に指定できません。')
                  this.loading = false
                  return
                }
              }
            }
          // 振替なし
          } else {
            row['exchange' + w] = null
          }

          // 担当者無し
          if (!row['trashStaff' + w]) {
            row['trashStaffId' + w] = null
          }
          if (!row['cleanStaff' + w]) {
            row['cleanStaffId' + w] = null
          }

          // 担当者IDがないところをセット
          if (row['trashStaff' + w] && !row['trashStaffId' + w]) {
            const staff = this.staffList.find((s) => {
              return row['trashStaff' + w] == s.userName
            })
            if (staff && staff.userId) {
              row['trashStaffId' + w] = staff.userId
            }
          }
          if (row['cleanStaff' + w] && !row['cleanStaffId' + w]) {
            const staff = this.staffList.find((s) => {
              return row['cleanStaff' + w] == s.userName
            })
            if (staff && staff.userId) {
              row['cleanStaffId' + w] = staff.userId
            }
          }

          if (row['trashStaffId' + w]) {
            // 固定休確認とかぶっていないか
            if (!await this.checkHolidayWeek(row, num, wn, row['trashStaffId' + w])) {
              this.loading = false
              return
            }
          }

          if (row['cleanStaffId' + w]) {
            // 固定休確認とかぶっていないか
            if (!await this.checkHolidayWeek(row, num, wn, row['cleanStaffId' + w])) {
              this.loading = false
              return
            }
          }
        }
        if (!flg) {
          this.loading = false
          await dialogs.showErrorDialog('ゴミ出し・清掃　未選択', 'どちらの曜日も未選択です。')
          return
        }
        this.reload++
      }

			// 登録
			try {
        const param = {
          ...this.val,
          works: this.works,
          insertUser: this.$store.getters.user.id
        }
        await backend.postData('rls/saveMst', param)

				// ログ登録
				logManager.recordingByRegist(
					this,
					this.isNew,
					'RLSマスタ',
          `${this.val.site} の情報`
				)
        this.$emit('getData')
				this.closed()
			} catch (error) {
        this.loading = false
				alert('エラーが発生しました。再度登録してください。\r\n' + error)
			}
		},

    /**
     * 勤務形態の確認
     * @param arr 対象曜日
     * @param wn 曜日名
     * @param type ゴミ・清掃
     */
    async validateAttendance(arr, wn, type) {
      if (arr.length > 1) {
        if (arr.includes('毎週')) {
          await dialogs.showErrorDialog(type + 'の' + wn + '曜日が不正です', '「毎週」を選択している場合、他の値は選択不可です。\r\n修正をお願いいたします。')
          return false
        }
        if (arr.includes('隔週')) {
          await dialogs.showErrorDialog(type + 'の' + wn + '曜日が不正です', '「隔週」を選択している場合、他の値は選択不可です。\r\n修正をお願いいたします。')
          return false
        }
      }
      return true
    },

    /**
     * 勤務形態のIDを取得
     * @param row 対象行
     * @param key 対象プロパティ
     */
    getAttendanceId(row, key) {
      const res = []
      for (let idx = 0; idx < ATTENDANCE.length; idx++) {
        const list = ATTENDANCE[idx]

        for (let i = 0; i < row[key].length; i++) {
          const tar = row[key][i]
          if (list.name == tar) {
            res.push(list.id)
          }
        }
      }
      row[key + 'Id'] = res
    },

    /**
     * 勤務形態の名前を取得
     * @param row 対象行
     * @param key 対象プロパティ
     */
    getAttendanceName(row, key) {
      const res = []
      for (let idx = 0; idx < ATTENDANCE.length; idx++) {
        const list = ATTENDANCE[idx]

        for (let i = 0; i < row[key].length; i++) {
          const tar = row[key][i]
          if (list.id == tar) {
            res.push(list.name)
          }
        }
      }
      row[key] = res
    },

    /**
     * 固定休確認
     * @param row 対象データ
     * @param num 曜日番号
     * @param wn 曜日名
     */
    async checkHolidayWeek(row, num, wn, staffId) {
      // 明日以降対象のマスタデータにて、確認
      if (!row.endDate || row.endDate > moment().format('YYYY-MM-DD')) {
        const staff = this.staffList.find((s) => {
          return s.userId == staffId
        })
        if (staff && staff.holidayWeeks && staff.holidayWeeks.length) {
          if (staff.holidayWeeks.includes(num)) {
            await dialogs.showErrorDialog(staff.userName + 'さんは' + wn + '曜は休みです', '固定休にかぶっています。\r\n曜日を変更するか、ユーザー設定で固定休の曜日を変更してください。')
            return false
          }
        }
      }

      return true
    },

		/**
		 * 初期化
		 */
		closed() {
      this.loading = false
			this.isNew = false
			this.val = utils.clone(ITEM)
      this.works = [utils.clone(WORK)]
      this.siteList = []
      this.byMonth = false
      this.attendanceList = utils.clone(ATTENDANCE)
      this.$emit('closed')
		},

    /**
     * 物件概要書開く
     */
    openOutline(siteCode) {
      const resolvedRoute = this.$router.resolve({
        name: 'SiteOutlineEdit',
        query: {
          siteCode
        }
      })
      window.open(resolvedRoute.href, '_blank')
    },

    /**
     * カレンダーモーダル
     */
    openCalendar() {
      this.siteCalendar = { siteCode: this.val.siteCode }
      this.siteCalendarOpen = true
    },

    /**
     * カレンダーモーダル閉じる
     */
    closedCalendar() {
      this.siteCalendar = null
      this.siteCalendarOpen = false
    },

    /**
     * 削除ボタン
     */
    async deleteBtn(siteCode) {
      const res = await dialogs.showConfirmDialog('本当に削除しますか？', this.val.site + 'のマスタを削除してよろしいでしょうか？')
      if (res != 'YES') {
        return
      }
      try {
        await backend.postData('rls/deleteMst', { siteCode })

				// ログ登録
        logManager.recording(this, logManager.Loglevel.INFO, 'RLSマスタ', '削除', `${this.val.site} を削除しました。`)
        this.$emit('getData')
				this.closed()

      } catch (error) {
        alert('保存できませんでした。再度お願いします。')
      }
    }
	}
}

</script>
<style scoped>
textarea {
  field-sizing: content;
}

.multiselect >>> .multiselect__tags {
  padding-right: 22px !important;
}

.clean >>> .multiselect__tag {
  background: #df4ddf !important;
}

.multiselect >>> .multiselect__select {
  padding-right: 4px !important;
}

.bar {
  writing-mode: vertical-rl
}

.staff-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2列 */
  gap: 8px; /* 行・列の間隔 */
}

.form {
  height: calc(100vh - 65px);
}

.w-135px {
  width: 135px;
}

.staff-input >>> .v-suggest input {
  font-size: smaller !important;
  font-weight: bold !important;
  padding-left: 4px !important;
  padding-right: 30px !important;
}

.yellow >>> .v-suggest input {
  background: rgb(243, 243, 40) !important;
}
</style>